"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseKicadNetlist = parseKicadNetlist;
const NodeParser_1 = require("../common/NodeParser");
const Util_1 = require("../Util");
function parseKicadNetlist(sourceFile, contents, designId = 'kicad-netlist') {
    const warnings = [];
    try {
        const rootNode = NodeParser_1.SExpressionFileParser.Parse(contents);
        if (rootNode.name !== 'export') {
            warnings.push(`Expected root node 'export', found '${rootNode.name}'`);
        }
        const schematic = {
            modelType: 'schematic',
            designId,
            designName: 'KiCad Netlist',
            sourceFile,
            sheetIndex: 0,
            grid: { distance: 50, units: 'mm' },
            edges_bbox: {
                minx: Number.POSITIVE_INFINITY,
                miny: Number.POSITIVE_INFINITY,
                maxx: Number.NEGATIVE_INFINITY,
                maxy: Number.NEGATIVE_INFINITY,
            },
            initial_zoombox: {
                minx: Number.POSITIVE_INFINITY,
                miny: Number.POSITIVE_INFINITY,
                maxx: Number.NEGATIVE_INFINITY,
                maxy: Number.NEGATIVE_INFINITY,
            },
            layerSet: 'default',
            drawings: {},
            modules: [],
            nets: {},
            warnings: [],
            ports: {},
            metadata: {
                title: '',
                revision: '',
                company: '',
                date: '',
            },
        };
        const designNode = rootNode.nodes.find((n) => n.name === 'design');
        const componentsNode = rootNode.nodes.find((n) => n.name === 'components');
        const netsNode = rootNode.nodes.find((n) => n.name === 'nets');
        if (designNode) {
            parseDesignMetadata(designNode, schematic);
        }
        const componentMap = new Map();
        if (componentsNode) {
            parseComponents(componentsNode, componentMap);
        }
        else {
            throw new Error('No components found in netlist');
        }
        for (const [ref, compInfo] of componentMap) {
            const module = {
                ref,
                name: ref,
                footprintRef: compInfo.footprint || 'Unknown',
                componentRef: ref,
                center: [0, 0],
                layer: 'F',
                transform: { angle: 0, mirrored: [false, false] },
                pinNets: {},
                drawProperties: {},
            };
            schematic.modules.push(module);
        }
        if (netsNode) {
            parseNets(netsNode, schematic);
        }
        else {
            throw new Error('No nets found in netlist');
        }
        return { schematic, warnings };
    }
    catch (error) {
        const errorMsg = error instanceof Error ? error.message : 'Unknown error';
        warnings.push(`Failed to parse KiCad netlist: ${errorMsg}`);
        throw new Error(`KiCad netlist parsing failed: ${errorMsg}`);
    }
}
function parseDesignMetadata(designNode, schematic) {
    for (const child of designNode.nodes) {
        switch (child.name) {
            case 'source':
                schematic.metadata.source = child.values[0] ?? '';
                break;
            case 'date':
                schematic.metadata.date = child.values[0] ?? '';
                break;
            case 'tool':
                schematic.metadata.title = child.values[0] ?? 'KiCad';
                break;
        }
    }
}
function parseComponents(componentsNode, componentMap) {
    for (const compNode of componentsNode.nodes) {
        if (compNode.name !== 'comp') {
            continue;
        }
        let ref = '';
        let value = '';
        let footprint = '';
        for (const child of compNode.nodes) {
            if (child.name === 'ref') {
                ref = (0, Util_1.removeQuotes)(child.values[0] ?? '');
            }
            else if (child.name === 'value') {
                value = (0, Util_1.removeQuotes)(child.values[0] ?? '');
            }
            else if (child.name === 'footprint') {
                footprint = (0, Util_1.removeQuotes)(child.values[0] ?? '');
            }
        }
        if (ref) {
            componentMap.set(ref, { value, footprint });
        }
    }
}
function writesNumberedPinFunctions(tool) {
    const major = /^Eeschema\s+(\d+)\./.exec((0, Util_1.removeQuotes)(tool))?.[1];
    return major !== undefined && Number(major) >= 10;
}
function parseNets(netsNode, schematic) {
    const tool = schematic.metadata?.title;
    const numberedPinFunctions = writesNumberedPinFunctions(typeof tool === 'string' ? tool : '');
    for (const netNode of netsNode.nodes) {
        if (netNode.name !== 'net') {
            continue;
        }
        let netName = '';
        for (const child of netNode.nodes) {
            if (child.name === 'name') {
                netName = (0, Util_1.removeQuotes)(child.values[0] ?? '');
            }
        }
        const connections = [];
        for (const nodeChild of netNode.nodes) {
            if (nodeChild.name === 'node') {
                let ref = '';
                let pin = '';
                let pinFunction;
                for (const child of nodeChild.nodes) {
                    if (child.name === 'ref') {
                        ref = (0, Util_1.removeQuotes)(child.values[0] ?? '');
                    }
                    else if (child.name === 'pin') {
                        pin = (0, Util_1.removeQuotes)(child.values[0] ?? '');
                    }
                    else if (child.name === 'pinfunction') {
                        pinFunction = (0, Util_1.removeQuotes)(child.values[0] ?? '');
                    }
                }
                if (pinFunction && numberedPinFunctions && pinFunction.endsWith(`_${pin}`)) {
                    pinFunction = pinFunction.slice(0, -(pin.length + 1));
                }
                if (ref && pin) {
                    connections.push({
                        moduleRef: ref,
                        moduleName: ref,
                        pinRef: pin,
                        ...(pinFunction ? { pinFunction } : {}),
                    });
                    const module = schematic.modules.find((m) => m.ref === ref);
                    if (module) {
                        module.pinNets[pin] = netName;
                    }
                }
            }
        }
        schematic.nets[netName] = {
            name: netName,
            connections,
        };
    }
}
//# sourceMappingURL=kicadNetlistParser.js.map